<!--
* @description  文字说明提示
* @fileName  Tooltip
!-->
<template>
  <div id='Tooltip' class='Tooltip'>
    <div class="toolTip_box">
      <slot></slot>
      <div class="toolTip_hover" :style="{top: tipType=='default'? 24+'px':30+'px'}">
        <i :class="{'triangle':(tipType!=='default')}"></i>
        <div class="tip_content" :class="[(tipType=='default')?'bgWhite':'bgDark']">
          {{tipContent}}
          <slot name='contentTip'></slot>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: { // 父辈向子辈传参

    //   提示内容
    tipContent: {
      type: [String],
      default: ''
    },
    // 类型颜色背景样式   default:默认白色   dark:黑色
    tipType: {
      type: [String],
      default: 'default'
    },

  },
  name: 'Tooltip',
  data() {
    return {

    }
  },
  created() { // 实例被创建之后执行代码

  },
  computed: { // 计算属性

  },
  components: { // 组件的引用

  },
  methods: { // 方法

  },
  mounted() { // 页面进入时加载内容

  },
  watch: { // 监测变化

  }
}
</script>
<style lang='scss' scoped>
/*浮框 css*/
.toolTip_box {
  position: relative;
  cursor: pointer;
  z-index: 10;
}

.toolTip_box:hover .toolTip_hover {
  // display: inline-block;
  visibility: visible;
  opacity: 1;
  transition: opacity 0.5s, visibility 0.5s;
}

.toolTip_hover {
  cursor: text;
  // display: none;
  visibility: hidden;
  position: absolute;
  left: 100px;
  //   top: 10px;
  z-index: 999;
  opacity: 0;
  transition: opacity 0.5s, visibility 0.5s;
}

.toolTip_hover .tip_content {
  margin: 0;
  line-height: 20px;
  font-size: 13px;
  //   text-align: left !important;
  word-break: break-all;
  padding: 8px;
  box-sizing: border-box;
}

.bgWhite {
  max-width: 520px;
  color: #333;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  left: 0;
  width: max-content;
}

.bgDark {
  max-width: 200px;
  border-radius: 4px;
  font-weight: 400;
  color: #ffffff;
  width: max-content;
  left: 50%;
  transform: translate(-45%, 0);
  background: #333333;
}
.triangle {
  position: absolute;
  left: -4%;
  transform: translate(50%, 0);
  background: url(../../../../../static/img/triangle-1.png) no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  width: 16px;
  height: 8px;
  top: -8%;
  z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// src/components/backstageManagement/public/Tooltip/Tooltip.vue